import React, { Component } from "react";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as VouchersActions,
  Selectors as VouchersSelectors,
} from "store/ducks/vouchers";

import { Form, Loading } from "components";

class CustomForm extends Component {
  static defaultProps = {
    edit: false,
  };

  state = {
    data: this.props.data,
  };

  componentDidMount() {
    const { getVouchersPlansRequest } = this.props;

    getVouchersPlansRequest();
  }

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { onChange } = this.props;

    if (oldProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleChangeInput = (e) => {
    const { name, value } = e.target;
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleToggleActive = () => {
    const { data } = this.state;

    this.setState({ data: { ...data, active: !data.active } });
  };

  handleSelectPlans = (plan_ids) => {
    const { data } = this.state;

    this.setState({ data: { ...data, plan_ids } });
  };

  handleSave = (e) => {
    e.preventDefault();

    const { onSave } = this.props;
    onSave();
  };

  render() {
    const { data } = this.state;
    const { errors, saving, plans } = this.props;

    return (
      <Form className="page-form" onSubmit={this.handleSave}>
        <h3 className="form-title">Voucher (pontos)</h3>

        <Form.Field>
          <Form.Label>Título</Form.Label>
          <Form.Input
            name="title"
            placeholder="Título do voucher"
            value={data.title}
            onChange={this.handleChangeInput}
            errors={errors.title}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Pontos</Form.Label>
          <Form.Input
            name="value"
            placeholder="Pontos"
            value={data.value}
            onChange={this.handleChangeInput}
            errors={errors.value}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Valor (R$)</Form.Label>
          <Form.Input
            name="discount"
            placeholder="Valor em (R$)"
            value={data.discount}
            onChange={this.handleChangeInput}
            errors={errors.discount}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Validade (dias)</Form.Label>
          <Form.Input
            name="days_to_expire"
            placeholder="Validade em dias"
            value={data.days_to_expire}
            onChange={this.handleChangeInput}
            errors={errors.days_to_expire}
          />
        </Form.Field>

        <Form.Field className="field-select">
          <Form.Label>Planos</Form.Label>
          <Form.Select
            isMulti
            placeholder="Selecione os planos"
            onChange={this.handleSelectPlans}
            value={data.plan_ids}
            options={plans.data}
          />
        </Form.Field>

        <Form.Field className="checkbox-field">
          <Form.Label>Ativar Voucher</Form.Label>
          <Form.Checkbox
            checked={data.active}
            onChange={this.handleToggleActive}
          />
        </Form.Field>

        <div className="buttons">
          <Link to="/points/vouchers" className="button-cancel">
            Cancelar
          </Link>

          <Form.Button
            className="button-save"
            disabled={saving}
            onClick={this.handleSave}
          >
            {saving ? (
              <Loading type="btn" size="small" text="Salvando..." />
            ) : (
              "Salvar"
            )}
          </Form.Button>
        </div>
      </Form>
    );
  }
}

const mapState = (state) => ({
  plans: {
    ...state.vouchers.plans,
    data: VouchersSelectors.plans(state.vouchers.plans.data),
  },
});

const mapActions = (dispatch) => bindActionCreators(VouchersActions, dispatch);

export default connect(mapState, mapActions)(CustomForm);
